import React, { useState, useCallback, useEffect } from 'react';
import ProcessIndicator from '../ProcessIndicator';
import { CompanyDetailsProgresses } from 'assets/helperdata/client/company-details-progress';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { MdOutlineFileUpload } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-hot-toast';
import { Skeleton } from '@mui/material';
import Select from 'react-select';
import { FaSpinner } from 'react-icons/fa';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { PlusIcon, InfoIcon } from 'ui-component/custom-icons/icons';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';

const allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];

const validateFileExtension = (fileName) => {
	const extension = fileName.split('.').pop().toLowerCase();
	return allowedExtensions.includes(extension);
};

const validateFileExtensionforLogo = (fileName) => {
	const extension = fileName.split('.').pop().toLowerCase();
	return allowedExtensions.includes(extension);
};

// ✅ Clear
const CompanyDocuments = () => {
	const history = useNavigate();
	const [isPageLoading, setIsPageLoading] = useState(true);
	const [vatCheckTimer, setVatCheckTimer] = useState();
	const [salesManagers, setSalesManagers] = useState([]);
	const [vatValidationAlert, setVatvalidationlert] = useState();
	const clientUser = useSelector((state) => state.main.client);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [logo, setLogo] = useState('');
	const MAX_FILE_SIZE_MB = 1;
	const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
	const [showVatUploadBlocker, setShowVatUploadBlocker] = useState(false);
	const [showRegistrationUploadBlocker, setShowRegistrationUploadBlocker] = useState(false);
	const [showLogoUploadBlocker, setShowLogoUploadBlocker] = useState(false);
	const [isInProgress, setIsInProgress] = useState(false);
	const [isFormProcessing, setIsFormProcessing] = useState(false);
	const [data, setData] = useState({
		vatCode: '',
		vatDocument: '',
		registrationNumber: '',
		registrationDocument: '',
		salesManager: '',
		companyLogo: '',
		id: clientUser?.data?.id
	});
	const [userAddress, setUserAddress] = useState(null);
	const [requireVat, setRequireVat] = useState(false);
	const [showVatField, setShowVatField] = useState(false);
	const [isVatApplicable, setIsVatApplicable] = useState(false);
	const [attachmentFiles, setAttachmentFiles] = useState({
		isVatProcessing: true,
		vatFileName: '',
		vatFileSize: '',
		vatFileExtension: '',
		isRegistrationProcessing: true,
		registrationFileName: '',
		registrationFileSize: '',
		registrationFileExtension: '',
		isCompanyLogoProcessing: true,
		companyLogoFileName: '',
		companyLogoFileSize: '',
		companyLogoFileExtension: '',
	})

	const vatValidationCountries = [
		'Austria',
		'Belgium',
		'France',
		'Germany',
		'Liechtenstein',
		'Luxembourg',
		'Monaco',
		'Netherlands',
		'Switzerland',
		'Denmark',
		'Estonia',
		'Finland',
		'Iceland',
		'Ireland',
		'Latvia',
		'Lithuania',
		'Norway',
		'Sweden',
		'United Kingdom',
		'Albania',
		'Andorra',
		'Bosnia and Herzegovina',
		'Croatia',
		'Greece',
		'Italy',
		'Kosovo',
		'Malta',
		'Montenegro',
		'North Macedonia',
		'Portugal',
		'San Marino',
		'Serbia',
		'Slovenia',
		'Spain',
		'Vatican City',
		'Belarus',
		'Bulgaria',
		'Czech Republic',
		'Hungary',
		'Moldova',
		'Poland',
		'Romania',
		'Russia',
		'Slovakia',
		'Ukraine',
	];
	const countriesWithRequiredVat = [
		'Austria',
		'Belgium',
		'France',
		'Germany',
		'Liechtenstein',
		'Luxembourg',
		'Monaco',
		'Netherlands',
		'Switzerland',
		'Denmark',
		'Estonia',
		'Finland',
		'Iceland',
		'Ireland',
		'Latvia',
		'Lithuania',
		'Norway',
		'Sweden',
		'United Kingdom',
		'Albania',
		'Andorra',
		'Bosnia and Herzegovina',
		'Croatia',
		'Greece',
		'Italy',
		'Kosovo',
		'Malta',
		'Montenegro',
		'North Macedonia',
		'Portugal',
		'San Marino',
		'Serbia',
		'Slovenia',
		'Spain',
		'Vatican City',
		'Belarus',
		'Bulgaria',
		'Czech Republic',
		'Hungary',
		'Moldova',
		'Poland',
		'Romania',
		'Russia',
		'Slovakia',
		'Ukraine',
	]

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		api.getSelectOptionsListClient('salesperson').then((res) => {
			const tempsalesPerson = res.data.map((item) => ({ id: item.id, name: `${item.first_name} ${item.last_name || ''}` }));
			setSalesManagers(tempsalesPerson);
		});
		if (clientUser?.data?.id) {
			api.getClientInformation(clientUser?.data?.id).then((res) => {
				setIsPageLoading(false);
				if (res?.data?.companyBillingAddress?.country) {

				}
				if (res?.data?.companyDoc) {
					let vatDocumentName = '';
					if (res.data?.companyDoc?.vat_doc) {
						const vatDocumentPath = res.data.companyDoc.vat_doc;
						const vatDocumentExtension = vatDocumentPath.split('.').pop();
						vatDocumentName = `VAT.${vatDocumentExtension}`;
					}
					const registrationDocumentPath = res.data.companyDoc.registration_doc;
					const registrationDocumentExtension = registrationDocumentPath?.split('.').pop();
					const registrationDocumentName = `Registration.${registrationDocumentExtension}`;
					const companyLogoPath = res.data.companyDoc.company_logo;
					const companyLogoExtension = companyLogoPath?.split('.').pop();
					const companyLogoName = `CompanyLogo.${companyLogoExtension}`;

					setUserAddress(res.data.companyBillingAddress.country);

					if (countriesWithRequiredVat.includes(res.data.companyBillingAddress.country)) {
						setRequireVat(true);
						setShowVatField(true);
						setIsVatApplicable(true)
					} else {
						if (res.data.companyDoc?.is_vat_applicable === 'Applicable') {
							setShowVatField(true);
							setIsVatApplicable(true)

						} else {

							setShowVatField(false);
							setIsVatApplicable(false)
						}
					}



					setLogo(companyLogoName);
					setData({
						vatCode: res.data.companyDoc.vat_code,
						vatDocument: res.data.companyDoc.vat_doc,
						registrationNumber: res.data.companyDoc.registration_number,
						registrationDocument: res.data.companyDoc.registration_doc,
						salesManager: res.data.companyDoc.sales_manager_id,
						companyLogo: res.data.companyDoc.company_logo,
						id: clientUser?.data?.id
					});

					setAttachmentFiles((prev) => ({
						...prev,
						isVatProcessing: false,
						vatFileName: res.data?.companyDoc?.vat_filename,
						vatFileSize: res.data?.companyDoc?.vat_file_size,
						vatFileExtension: res.data?.companyDoc?.vat_extension,
						isRegistrationProcessing: false,
						registrationFileName: res.data?.companyDoc?.registration_filename,
						registrationFileSize: res.data?.companyDoc?.registration_file_size,
						registrationFileExtension: res.data?.companyDoc?.registration_extension,
						isCompanyLogoProcessing: false,
						companyLogoFileName: res.data?.companyDoc?.company_logo_filename,
						companyLogoFileSize: res.data?.companyDoc?.company_logo_file_size,
						companyLogoFileExtension: res.data?.companyDoc?.company_logo_extension,
					}));


				} else {
					if (countriesWithRequiredVat.includes(res.data.companyBillingAddress.country)) {
						setRequireVat(true);
						setShowVatField(true);
						setIsVatApplicable(true)
					} else {
						if (res.data.companyDoc?.is_vat_applicable === 'Applicable') {
							// setRequireVat(true);
							setShowVatField(true);
							setIsVatApplicable(true)

						} else {

							// setRequireVat(false);
							setShowVatField(false);
							setIsVatApplicable(false)
						}
					}

					setUserAddress(res.data.companyBillingAddress.country);
				}
			});
		}
	}, []);


	const handlevatValidation = (e) => {
		let inputValue = e.target.value;

		setData((prevData) => ({ ...prevData, vatCode: e.target.value }));
		inputValue = inputValue.trim();
		const words = inputValue.split(' ');
		const capitalizedWords = words.map((word) => word.substr(0).toUpperCase());
		inputValue = capitalizedWords.join(' ');
		e.target.value = inputValue;

		if (vatCheckTimer) {
			clearTimeout(vatCheckTimer);
		}

		let timeout = setTimeout(() => {
			vatNumberValidation(inputValue);
		}, 1000);

		setVatCheckTimer(timeout);
	};

	const onDrop = useCallback((acceptedFiles) => {

		const file = acceptedFiles[0];
		if (!file) return;

		if (file.size > MAX_FILE_SIZE_BYTES) {
			toast.error('Company logo size should not exceed 1MB.');
			return;
		}

        let sizeStr = "";
        const sizeInKB = file.size / 1024;
        if (sizeInKB >= 1024) {
            const sizeInMB = sizeInKB / 1024;
            sizeStr = `${sizeInMB.toFixed(2)} MB`;
        } else {
            sizeStr = `${sizeInKB.toFixed(2)} KB`;
		}
		
		setAttachmentFiles((prev) => ({
			...prev,
			isCompanyLogoProcessing: true,
			companyLogoFileName: file.name,
			companyLogoFileExtension: file.type,
			companyLogoFileSize: sizeStr,
		}));

		if (validateFileExtensionforLogo(acceptedFiles[0].name)) {
			setShowLogoUploadBlocker(true)
			const formData = new FormData();
			formData.append('type', 'logo');
			formData.append('doc', acceptedFiles[0]);

			api
				.storeClientDocuments(data.id, formData)
				.then((res) => {
					if (res.status === true) {
						setData((prevData) => ({ ...prevData, companyLogo: acceptedFiles[0] }));
						setLogo(acceptedFiles[0].name);
						setShowLogoUploadBlocker(false);

						setTimeout(() => {
							setAttachmentFiles((prev) => ({
								...prev,
								isCompanyLogoProcessing: false,
								companyLogoFileName: file.name,
								companyLogoFileExtension: file.type,
								companyLogoFileSize: sizeStr,
							}));
						}, 1000);
					}
				})
				.catch((err) => {
					setShowLogoUploadBlocker(false);	
					console.log(err);
				});

		} else {
			toast.error('Invalid file extension. Please select a JPEG, JPG, PNG, or PDF file.');
		}
	}, []);
	const handleSalesManagerSelect = (selectedOption) => {
		setData({ ...data, salesManager: selectedOption.value });
		const completionPercentage = calculateCompletionPercentage();
	};

	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		accept: '.pdf, .jpeg, .jpg, .png',
		multiple: false
	});

	const vatNumberValidation = (vatNumbr) => {
		vatNumbr = vatNumbr.trim();
		const words = vatNumbr.split(' ');
		const capitalizedWords = words.map((word) => word.substr(0).toUpperCase());
		vatNumbr = capitalizedWords.join(' ');
		if (vatNumbr) {
			setVatvalidationlert('loading');
			api.vatValidation(vatNumbr).then((res) => {
				if (res.errors) {
					setVatvalidationlert(false);
					toast.error('VAT Number is not valid');

				} else {
					if (res.format_valid == false) {
						toast.error('Format is not valid');
						setVatvalidationlert(false);
					} else if (res.registration_info?.is_registered == false) {
						toast.error('VAT Number is not registered.');
						setVatvalidationlert(false);
					} else if (res?.message?.includes('You used all your monthly requests')) {
						setVatvalidationlert(false);
						toast.error('You used all your monthly requests');
					} else {
						setVatvalidationlert(true);
					}
				}
				setData((prevData) => ({ ...prevData, vatCode: vatNumbr }));
			});
		} else {
			setData((prevData) => ({ ...prevData, vatCode: vatNumbr }));
		}
	};

	const onRegistrationDrop = useCallback((acceptedFiles) => {
		const file = acceptedFiles[0];
		if (!file) return;

		if (file.size > MAX_FILE_SIZE_BYTES) {
			toast.error('Registration File size should not exceed 1MB.');
			return;
		}

        let sizeStr = "";
        const sizeInKB = file.size / 1024;
        if (sizeInKB >= 1024) {
            const sizeInMB = sizeInKB / 1024;
            sizeStr = `${sizeInMB.toFixed(2)} MB`;
        } else {
            sizeStr = `${sizeInKB.toFixed(2)} KB`;
		}
		
		setAttachmentFiles((prev) => ({
			...prev,
			isRegistrationProcessing: true,
			registrationFileName: file.name,
			registrationFileExtension: file.type,
			registrationFileSize: sizeStr,
		}));
		
		if (validateFileExtension(acceptedFiles[0].name)) {

			setShowRegistrationUploadBlocker(true)
			const formData = new FormData();
			formData.append('type', 'reg');
			formData.append('doc', acceptedFiles[0]);

			api
				.storeClientDocuments(data.id, formData)
				.then((res) => {
					if (res.status === true) {
						setData((prevData) => ({ ...prevData, registrationDocument: acceptedFiles[0] }));
						setShowRegistrationUploadBlocker(false);

						setTimeout(() => {
							setAttachmentFiles((prev) => ({
								...prev,
								isRegistrationProcessing: false,
								registrationFileName: file.name,
								registrationFileExtension: file.type,
								registrationFileSize: sizeStr,
							}));
						}, 1000);
					}
				})
				.catch((err) => {
					setShowRegistrationUploadBlocker(false);	
					console.log(err);
				});

		} else {
			toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
		}
	}, []);

	const { getRootProps: getRegistrationRootProps, getInputProps: getRegistrationInputProps } = useDropzone({ onDrop: onRegistrationDrop });

	const onVATDrop = useCallback((acceptedFiles) => {

		const file = acceptedFiles[0];
		if (!file) return;

		if (file.size > MAX_FILE_SIZE_BYTES) {
			toast.error('VAT File size should not exceed 1MB.');
			return;
		}

        let sizeStr = "";
        const sizeInKB = file.size / 1024;
        if (sizeInKB >= 1024) {
            const sizeInMB = sizeInKB / 1024;
            sizeStr = `${sizeInMB.toFixed(2)} MB`;
        } else {
            sizeStr = `${sizeInKB.toFixed(2)} KB`;
		}
		
		setAttachmentFiles((prev) => ({
			...prev,
			isVatProcessing: true,
			vatFileName: file.name,
			vatFileExtension: file.type,
			vatFileSize: sizeStr,
		}));

		if (validateFileExtension(acceptedFiles[0].name)) {
			setShowVatUploadBlocker(true)

			const formData = new FormData();
			formData.append('type', 'vat');
			formData.append('doc', acceptedFiles[0]);

			api
				.storeClientDocuments(data.id, formData)
				.then((res) => {
					if (res.status === true) {
						setData((prevData) => ({ ...prevData, vatDocument: acceptedFiles[0] }));
						// setVat(acceptedFiles[0].name);
						setShowVatUploadBlocker(false);

						setTimeout(() => {
							setAttachmentFiles((prev) => ({
								...prev,
								isVatProcessing: false,
								vatFileName: file.name,
								vatFileExtension: file.type,
								vatFileSize: sizeStr,
							}));
						}, 1000);
					}
				})
				.catch((err) => {
					setShowVatUploadBlocker(false);	
					console.log(err);
				});

		} else {
			toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
		}
	}, []);

	const { getRootProps: getVATRootProps, getInputProps: getVATInputProps } = useDropzone({ onDrop: onVATDrop });

	const moveToNext = () => {
		if (data.salesManager === '') {
			toast.error('Please select a sales manager');
			setIsInProgress(false);
			setIsFormProcessing(false)
			return;
		}

		setIsInProgress(false);
		setIsFormProcessing(true)
		const formData = new FormData();
		formData.append('vatCode', data.vatCode);
		formData.append('vatDocument', data.vatDocument);
		formData.append('registrationNumber', data.registrationNumber);
		formData.append('registrationDocument', data.registrationDocument);
		formData.append('salesManager', data.salesManager);
		formData.append('companyLogo', data.companyLogo);
		formData.append('is_vat_applicable', isVatApplicable ? 'Applicable' : 'Not Applicable')

		api
			.updateClientDocuments(data.id, formData)
			.then((res) => {
				setIsFormProcessing(false)
				if (res.status === true) {
					toast.success('Company documents updated successfully');
					history('../client/company-bank-details');
				}
			})
			.catch((err) => {
				setIsFormProcessing(false)
				console.log(err);
			});

	};

	const moveToBack = () => {
		setIsInProgress(false);
		history('../client/company-address');
	};

	const calculateCompletionPercentage = () => {
		let fields = [];
		if (requireVat) {
			fields = ['vatCode', 'vatDocument', 'registrationNumber', 'registrationDocument', 'salesManager', 'companyLogo'];
		} else {
			fields = ['registrationNumber', 'registrationDocument', 'salesManager', 'companyLogo'];
		}
		const filledFields = fields.filter((field) => data[field]);
		return (filledFields.length / fields.length) * 100;
	};

	// Call this function whenever you want to get the completion percentage
	const completionPercentage = calculateCompletionPercentage();
	const { t } = useLanguage()

	return (
		<div className={`main-page-client ${isMobile ? 'padding-mobile-client' : ''}`}>
			<div className="actions-company-details-client">
				<ProcessIndicator
					isInProgress={isInProgress}
					processes={CompanyDetailsProgresses}
					currentIndex={3}
					completionPercentage={completionPercentage}
				/>
			</div>
			<div className="company-details-client-content">
				<div className="" style={{ justifyContent: 'space-between' }}>
					<table className="projectmix-table-vertical-client">
						<tbody>
							<tr>
								{!isMobile && <th></th>}

								<td className="fw-600" style={{ textAlign: isMobile ? 'left' : 'left', fontSize: isMobile ? 16 : 14 }}>
									{t('company-documents.company-documents')}
								</td>
							</tr>
							{isPageLoading ? (
								<>
									<tr>
										{!isMobile && (
											<th>
												<div>
													<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											</th>
										)}
										<td>
											<div style={{ padding: '4px 0' }}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										</td>
									</tr>
									{
										[...Array(3)].map((e, i) => (
											<>
												<tr>
													{!isMobile && (
														<th>
															<div>
																<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
															</div>
														</th>
													)}
													<td>
														<div style={{ padding: '4px 0' }}>
															<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<div style={{ padding: '4px 0' }}>
															<Skeleton variant="rounded" width="100%" height={80} style={{ borderRadius: '12px' }} />
														</div>
													</td>
												</tr>
											</>
										))
									}
								</>
								// [...Array(6)].map((e, i) => (
								// 	<tr key={i}>
								// 		{!isMobile && (
								// 			<th>
								// 				<div>
								// 					<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
								// 				</div>
								// 			</th>
								// 		)}
								// 		<td>
								// 			{isMobile && (
								// 				<div style={{ width: '150px' }}>
								// 					<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
								// 				</div>
								// 			)}
								// 			<div style={{ padding: '4px 0' }}>
								// 				<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
								// 			</div>
								// 		</td>
								// 	</tr>
								// ))
							) : (
								<>
									{!requireVat && (
										<tr>
											{!isMobile && <th></th>}
											<td>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '9px',
														marginBottom: '-8px'
													}}
												>
													<div className="group-chk-cmpny-dtls">
														<label className="client-page-checkbox">
															<input
																type="checkbox"
																name=""
																id=""
																checked={!isVatApplicable}
																onChange={() => {
																	setIsVatApplicable(!isVatApplicable);
																	if (isVatApplicable) {
																		setShowVatField(false);
																	} else {
																		setData({ ...data, vatCode: '', vatDocument: '' });
																		setVatvalidationlert(false);
																		setShowVatField(true);
																	}
																}}
															/>
															<span className="checkmark"></span>
														</label>
														<label htmlFor="">{t('company-documents.vat-not-applicable')}</label>
													</div>
												</div>
											</td>
										</tr>
									)}
									{showVatField && (
										<>
											<tr>
												{!isMobile && <th>VAT Code</th>}
												<td>
													{isMobile && <label className="onboard-label">VAT Code</label>}
													<input
														type="text"
														className="form-control"
														value={data.vatCode}
														style={{ color: 'black', borderColor: '#0066FF' }}
														onChange={(e) => {
															setData({ ...data, vatCode: e.target.value });
														}}
													/>
												</td>
											</tr>
											<tr>
												<td colSpan="2" >
													{
														attachmentFiles?.vatFileName ? (
															<>
																	
																<div className="row m-0" style={{ padding: '0' }}>
																	<div className="col-12" style={{ padding: '0' }}>
																		<div
																			className={`bg-white  w-100 border card-border-gray relative`}
																			style={{
																				borderRadius: '10px',
																				paddingTop: isMobile ? '10px' : '0',
																			}}
																		>
																			<div style={{ padding: '0px 15px' }}>
																				<div className="row">
																					<div className="col-12">
																						<div className="section-head row" style={{ padding: '0px 10px !important', paddingLeft: '0px', paddingBottom: '10px' }}>
																							<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-9 col-md-10">
																								<div className="flex align-items-center" style={{ gap: '10px' }}>
																									<div>
																										{(attachmentFiles?.vatFileExtension === 'application/pdf' || attachmentFiles?.vatFileExtension === 'pdf') ? (
																											<PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
																										) : (
																											<InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
																										)}
																									</div>
																									<div>
																										<div className="">
																											{attachmentFiles?.vatFileName}
																										</div>
																										<div className="text-gray-600" style={{ fontSize: '12px' }}>{attachmentFiles?.vatFileSize}</div>
				
																									</div>
																								</div>
																							</div>
																							<div className="actions col-2 flex align-items-center justify-end" style={{ gap: '8px' }}>
																								
																								<div 
																									className="payment-modal-attachment-delete"
																									onClick={() => {
																										setData({ ...data, vatDocument: null })
																										setAttachmentFiles((prev) => ({
																											...prev,
																											isVatProcessing: false,
																											vatFileName: '',
																											vatFileExtension: '',
																											vatFileSize: '',
																										}))	
																									}}
																										
																								>
																									<svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
																										<path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
																									</svg>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																			
																			{
																				attachmentFiles?.isVatProcessing && (
																					<div className="card-footer p-0 border-0 bg-transparent" style={{ height: '4px', marginTop: '-4px' }}>
																						<div className="progress" style={{ height: '4px', borderRadius: '0', backgroundColor: 'transparent' }}>
																							<div 
																								className="progress-bar progress-bar-animated" 
																								role="progressbar" 
																								style={{ 
																									width: '100%', 
																									background: 'linear-gradient(90deg, #007bff 0%, #00d4ff 50%, #007bff 100%)',
																									backgroundSize: '200% 100%',
																									animation: 'loading-slide 2s infinite linear'
																								}}
																							></div>
																						</div>
																					</div>
				
																				)
																			}
				
																		</div>
																	</div>
																</div>
															</>
														) : (
															<>
																{isMobile && <label className="onboard-label">VAT Document</label>}
																{/* {showVatUploadBlocker && (
																	<div className="upload-input-blocker">
																		<FaSpinner style={{ animation: 'spin 2s linear infinite' }} /> Uploading...
																	</div>
																)} */}
																<div {...getVATRootProps()} style={{ position: 'relative' }}>
																	
																	<div
																		// className={`dragIconVAT ${data.vatDocument ? 'dragRegistration' : ''}`}
																		// style={{ position: 'relative', border: '1px solid #0066FF', borderRadius: '12px' }}
																		className={`${data.vatDocument ? 'dragIconVAT dragRegistration' : ''}`}
																		// style={{ position: 'relative', border: '1px solid #0066FF', borderRadius: '12px' }}
																	>
																		{data.vatDocument?.name ? (
																			<>
																				<button
																					className="btn remove-file-icon"
																					onClick={() => setData({ ...data, vatDocument: null })}
																					style={{ position: 'absolute', top: 2, right: 2 }}
																				>
																					<svg
																						id="Component_127_1"
																						height="12"
																						width="12"
																						data-name="Component 127 – 1"
																						xmlns="http://www.w3.org/2000/svg"
																						viewBox="0 0 19.295 19.289"
																					>
																						<path
																							id="Icon_ionic-ios-close"
																							data-name="Icon ionic-ios-close"
																							d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
																							transform="translate(-11.285 -11.289)"
																						/>
																					</svg>
																				</button>
																				<p className="dragText" style={{ padding: '0 10px' }}>
																					{data.vatDocument?.name ? data.vatDocument?.name : data.vatDocument?.split('/').pop()}
																				</p>
																			</>
																		) : (
																			<>
																				{/* <MdOutlineFileUpload className="UploadIcon" />
																				<p className="dragText">
																					{t('company-documents.drop-here')}
																				</p> */}
																				<div className="add-item-empty-div" style={{ alignItems: 'center' }}>
																					<div
																						className="text-primary"
																						style={{
																							marginTop: '1px',
																							padding: '5px 7px',
																							border: '2px solid #9e9e9e',
																							borderRadius: '32px',
																						}}
																					>
																						<PlusIcon height="16px" width="16px" />
																					</div>
																					<div style={{ marginLeft: '10px' }}>
																						<div
																							className='flex'
																							style={{
																								gap: '5px'
																							}}
																						>
																							<span className="fw-500">Drag & Drop or Click to Upload</span>
																							<span className="text-gray-700">OR</span>
																							<span className="text-blue-600 fw-500">Browse Files</span>
																						</div>
																						<div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
																							<InfoIcon width='14px' height='14px' />
																							<span>
																								png, jpg, jpeg or pdf (Max file size: 1MB)
																							</span>
																						</div>
																					</div>
																				</div>
																			</>
																		)}
																	</div>
																	<input {...getVATInputProps({ disabled: vatValidationAlert === 'loading' })} style={{ display: 'none' }} />
																</div>
															</>
														)	
													}
												</td>
											</tr>
										</>
									)}
									<tr>
										{!isMobile && <th> {t('company-documents.registration-number')}</th>}
										<td>
											{isMobile && <label className="onboard-label">{t('company-documents.registration-number')}</label>}
											<input
												type="text"
												value={data.registrationNumber}
												className="form-control"
												style={{ color: 'black', borderColor: '#0066FF' }}
												onChange={(e) => {
													setData({ ...data, registrationNumber: e.target.value });
												}}
											/>
										</td>
									</tr>
									<tr>
										{/* {!isMobile && <th></th>} */}
										<td colSpan="2">
											{
												attachmentFiles?.registrationFileName ? (
													<>
															
														<div className="row m-0" style={{ padding: '0' }}>
															<div className="col-12" style={{ padding: '0' }}>
																<div
																	className={`bg-white  w-100 border card-border-gray relative`}
																	style={{
																		borderRadius: '10px',
																		paddingTop: isMobile ? '10px' : '0',
																	}}
																>
																	<div style={{ padding: '0px 15px' }}>
																		<div className="row">
																			<div className="col-12">
																				<div className="section-head row" style={{ padding: '0px 10px !important', paddingLeft: '0px', paddingBottom: '10px' }}>
																					<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-9 col-md-10">
																						<div className="flex align-items-center" style={{ gap: '10px' }}>
																							<div>
																								{(attachmentFiles?.registrationFileExtension === 'application/pdf' || attachmentFiles?.registrationFileExtension === 'pdf') ? (
																									<PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
																								) : (
																									<InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
																								)}
																							</div>
																							<div>
																								<div className="">
																									{attachmentFiles?.registrationFileName}
																								</div>
																								<div className="text-gray-600" style={{ fontSize: '12px' }}>{attachmentFiles?.registrationFileSize}</div>
		
																							</div>
																						</div>
																					</div>
																					<div className="actions col-2 flex align-items-center justify-end" style={{ gap: '8px' }}>
																						
																						<div 
																							className="payment-modal-attachment-delete"
																							onClick={() => {
																								setData({ ...data, registrationDocument: null })
																								setAttachmentFiles((prev) => ({
																									...prev,
																									isRegistrationProcessing: false,
																									registrationFileName: '',
																									registrationFileExtension: '',
																									registrationFileSize: '',
																								}))	
																							}}
																								
																						>
																							<svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
																								<path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
																							</svg>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	
																	{
																		attachmentFiles?.isRegistrationProcessing && (
																			<div className="card-footer p-0 border-0 bg-transparent" style={{ height: '4px', marginTop: '-4px' }}>
																				<div className="progress" style={{ height: '4px', borderRadius: '0', backgroundColor: 'transparent' }}>
																					<div 
																						className="progress-bar progress-bar-animated" 
																						role="progressbar" 
																						style={{ 
																							width: '100%', 
																							background: 'linear-gradient(90deg, #007bff 0%, #00d4ff 50%, #007bff 100%)',
																							backgroundSize: '200% 100%',
																							animation: 'loading-slide 2s infinite linear'
																						}}
																					></div>
																				</div>
																			</div>
		
																		)
																	}
		
																</div>
															</div>
														</div>
													</>
												) : (
													<>
														{isMobile && <label className="onboard-label">Registration Document</label>}
														<div {...getRegistrationRootProps()} style={{ position: 'relative' }}>

															{/* {showRegistrationUploadBlocker && (
																<div className="upload-input-blocker">
																	<FaSpinner style={{ animation: 'spin 2s linear infinite' }} /> Uploading...
																</div>
															)} */}
															<div
																// className={`dragIconVAT ${data?.registrationDocument?.name ? 'dragRegistration' : ''}`}
																// style={{ position: 'relative', border: '1px solid #0066FF', borderRadius: '12px' }}
																className={`${data?.registrationDocument?.name ? 'dragIconVAT dragRegistration' : ''}`}
																// style={{ position: 'relative', border: '1px solid #0066FF', borderRadius: '12px' }}
															>
																{data.registrationDocument?.name ? (
																	<>
																		<button
																			className="btn remove-file-icon"
																			onClick={() => {
																				setData({ ...data, registrationDocument: null });
																			}}
																			style={{ position: 'absolute', top: 0, right: 0 }}
																		>
																			<svg
																				id="Component_127_1"
																				height="12"
																				width="12"
																				data-name="Component 127 – 1"
																				xmlns="http://www.w3.org/2000/svg"
																				viewBox="0 0 19.295 19.289"
																			>
																				<path
																					id="Icon_ionic-ios-close"
																					data-name="Icon ionic-ios-close"
																					d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
																					transform="translate(-11.285 -11.289)"
																				/>
																			</svg>
																		</button>
																		<p className="dragText" style={{ padding: '0 10px' }}>
																			{data.registrationDocument?.name ? data.registrationDocument?.name : data.registrationDocument?.split('/').pop()}
																		</p>
																	</>
																) : (
																	<>
																		<div className="add-item-empty-div" style={{ alignItems: 'center' }}>
																			<div
																				className="text-primary"
																				style={{
																					marginTop: '1px',
																					padding: '5px 7px',
																					border: '2px solid #9e9e9e',
																					borderRadius: '32px',
																				}}
																			>
																				<PlusIcon height="16px" width="16px" />
																			</div>
																			<div style={{ marginLeft: '10px' }}>
																				<div
																					className='flex'
																					style={{
																						gap: '5px'
																					}}
																				>
																					<span className="fw-500">Drag & Drop or Click to Upload</span>
																					<span className="text-gray-700">OR</span>
																					<span className="text-blue-600 fw-500">Browse Files</span>
																				</div>
																				<div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
																					<InfoIcon width='14px' height='14px' />
																					<span>
																						png, jpg, jpeg or pdf (Max file size: 1MB)
																					</span>
																				</div>
																			</div>
																		</div>
																		{/* <MdOutlineFileUpload className="UploadIcon" />
																		<p className="dragText">
																			{t('company-documents.drop-here')}
																		</p> */}
																	</>
																)}
															</div>
															<input {...getRegistrationInputProps({ disabled: false })} style={{ display: 'none' }} />{' '}
														</div>
													</>
												)	
											}
										</td>
									</tr>
									<tr>
										{!isMobile && <th>{t('company-documents.sales-manager')}</th>}
										<td>
											{isMobile && <label className="onboard-label">{t('company-documents.sales-manager')}</label>}
											<Select
												className="rs-container-est-blue-client"
												classNamePrefix="rs"
												isSearchable={true}
												name="customer"
												options={salesManagers?.map((y) => ({ label: y.name, value: y.id }))}
												value={salesManagers?.map((y) => ({ label: y.name, value: y.id }))?.find((y) => y?.value == data.salesManager)}
												onChange={handleSalesManagerSelect}
												menuPlacement="auto"
												menuPosition="fixed"
											/>
										</td>
									</tr>
									<tr>
										<th colSpan="2" style={{ paddingBottom: '5px' }}>{t('company-documents.company-logo')}</th>
									</tr>
									<tr>
										<td colSpan="2">
											{
												attachmentFiles?.companyLogoFileName ? (
													<>
															
														<div className="row m-0" style={{ padding: '0' }}>
															<div className="col-12" style={{ padding: '0' }}>
																<div
																	className={`bg-white  w-100 border card-border-gray relative`}
																	style={{
																		borderRadius: '10px',
																		paddingTop: isMobile ? '10px' : '0',
																	}}
																>
																	<div style={{ padding: '0px 15px' }}>
																		<div className="row">
																			<div className="col-12">
																				<div className="section-head row" style={{ padding: '0px 10px !important', paddingLeft: '0px', paddingBottom: '10px' }}>
																					<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-9 col-md-10">
																						<div className="flex align-items-center" style={{ gap: '10px' }}>
																							<div>
																								{(attachmentFiles?.companyLogoFileExtension === 'application/pdf' || attachmentFiles?.companyLogoFileExtension === 'pdf') ? (
																									<PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
																								) : (
																									<InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
																								)}
																							</div>
																							<div>
																								<div className="">
																									{attachmentFiles?.companyLogoFileName}
																								</div>
																								<div className="text-gray-600" style={{ fontSize: '12px' }}>{attachmentFiles?.companyLogoFileSize}</div>
		
																							</div>
																						</div>
																					</div>
																					<div className="actions col-2 flex align-items-center justify-end" style={{ gap: '8px' }}>
																						
																						<div 
																							className="payment-modal-attachment-delete"
																							onClick={() => {
																								setData({ ...data, companyLogo: null })
																								setAttachmentFiles((prev) => ({
																									...prev,
																									isCompanyLogoProcessing: false,
																									companyLogoFileName: '',
																									companyLogoFileExtension: '',
																									companyLogoFileSize: '',
																								}))	
																								setLogo(null);
																							}}
																								
																						>
																							<svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
																								<path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
																							</svg>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	
																	{
																		attachmentFiles?.isCompanyLogoProcessing && (
																			<div className="card-footer p-0 border-0 bg-transparent" style={{ height: '4px', marginTop: '-4px' }}>
																				<div className="progress" style={{ height: '4px', borderRadius: '0', backgroundColor: 'transparent' }}>
																					<div 
																						className="progress-bar progress-bar-animated" 
																						role="progressbar" 
																						style={{ 
																							width: '100%', 
																							background: 'linear-gradient(90deg, #007bff 0%, #00d4ff 50%, #007bff 100%)',
																							backgroundSize: '200% 100%',
																							animation: 'loading-slide 2s infinite linear'
																						}}
																					></div>
																				</div>
																			</div>
		
																		)
																	}
		
																</div>
															</div>
														</div>
													</>
												) : (
													<>

														{isMobile && <label className="onboard-label">{t('company-documents.company-logo')}</label>}
														<div {...getRootProps()} style={{ position: 'relative' }}>
																
															{/* {showLogoUploadBlocker && (
																<div className="upload-input-blocker">
																	<FaSpinner style={{ animation: 'spin 2s linear infinite' }} /> Uploading...
																</div>
															)} */}
															<div
																// className={`dragIconVAT ${logo ? 'dragRegistration' : ''}`}
																// style={{ position: 'relative', border: '1px solid #0066FF', borderRadius: '12px' }}
																className={`${logo ? 'dragIconVAT dragRegistration' : ''}`}
																// style={{ position: 'relative', border: '1px solid #0066FF', borderRadius: '12px' }}
															>
																{data.companyLogo?.name ? (
																	<>
																		<button
																			className="btn remove-file-icon"
																			onClick={() => {
																				setData({ ...data, companyLogo: null });
																				setLogo(null);
																			}}
																			style={{ position: 'absolute', top: 0, right: 0 }}
																		>
																			<svg
																				id="Component_127_1"
																				height="12"
																				width="12"
																				data-name="Component 127 – 1"
																				xmlns="http://www.w3.org/2000/svg"
																				viewBox="0 0 19.295 19.289"
																			>
																				<path
																					id="Icon_ionic-ios-close"
																					data-name="Icon ionic-ios-close"
																					d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
																					transform="translate(-11.285 -11.289)"
																				/>
																			</svg>
																		</button>
																		<p className="dragText" style={{ padding: '0 10px' }}>
																			{data.companyLogo?.name ? data.companyLogo?.name : data.companyLogo?.split('/').pop()}
																		</p>
																	</>
																) : (
																	<div className="add-item-empty-div" style={{ alignItems: 'center' }}>
																		<div
																			className="text-primary"
																			style={{
																				marginTop: '1px',
																				padding: '5px 7px',
																				border: '2px solid #9e9e9e',
																				borderRadius: '32px',
																			}}
																		>
																			<PlusIcon height="16px" width="16px" />
																		</div>
																		<div style={{ marginLeft: '10px' }}>
																			<div
																				className='flex'
																				style={{
																					gap: '5px'
																				}}
																			>
																				<span className="fw-500">Drag & Drop or Click to Upload</span>
																				<span className="text-gray-700">OR</span>
																				<span className="text-blue-600 fw-500">Browse Files</span>
																			</div>
																			<div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
																				<InfoIcon width='14px' height='14px' />
																				<span>
																					png, jpg, jpeg or pdf (Max file size: 1MB)
																				</span>
																			</div>
																		</div>
																	</div>
																)}
															</div>
															<input {...getInputProps({ disabled: false })} style={{ display: 'none' }} />{' '}
														</div>
													</>
												)	
											}
										</td>
									</tr>
								</>
							)}
						</tbody>
					</table>
				</div>
			</div>
			<div className="action-company-dtls-adrs-btn" style={{ marginTop: 10 }}>
				{isPageLoading ? (
					<div style={{ width: '102px' }}>
						<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
					</div>
				) : (
					<button
						className="btn btn-cmpny-dtls-action-back"
						onClick={() => {
							setIsInProgress(true);
							moveToBack();
						}}
					>
						<MdKeyboardArrowLeft /> {t('company-documents.back')}
					</button>
				)}
				{isPageLoading ? (
					<div style={{ width: '102px' }}>
						<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
					</div>
				) : (
					<button
						className={`btn btn-cmpny-dtls-action ${isFormProcessing ? 'disabled' : ''}`}
						disabled={isFormProcessing}
						onClick={() => {
							if (isFormProcessing) return;
							setIsFormProcessing(true);
							setIsInProgress(true);
							moveToNext();
						}}
					>
						{isFormProcessing ? (
							<div>
								<FaSpinner className="spinner" style={{ height: '18px' }} /> <span style={{ marginLeft: '-7px' }}>Please wait...</span>
							</div>
						) : (
							<>
								{t('company-documents.next')} <MdKeyboardArrowRight />
							</>
						)}
					</button>
				)}
			</div>
		</div>
	);
};

export default CompanyDocuments;
